import ProductList from "./list";
import Column from "@components/column";
import Header from "@commons/header";
import { Plus, ShoppingBasket, ShoppingCart } from "lucide-react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@store/index";

const ProductSetup = ({ state }: { state?: any }) => {
  console.log(state, "module");
  const { storeId } = useParams();
  const [searchTerm] = useSearchParams();
  const moduleName = searchTerm.get("module");
  const navigate = useNavigate();
  const { data: user } = useSelector((state: RootState) => state.user);
  return (
    <Column>
      {user.role === "admin" && (
        <Header
          title="Product Setup"
          icon={ShoppingCart}
          hasButton
          btnTitle="Add New Product"
          btnIcon={<Plus width={16} />}
          onClick={() =>
            navigate(
              `/admin/users/store/create-product/${storeId}?module=${state?.module?.name ? state?.module?.name.toLowerCase() : moduleName.toLowerCase()}`,
              { state }
            )
          }
        />
      )}

      <ProductList
        storeId={storeId}
        moduleId={state?.module?.id}
        moduleName={
          state?.module?.name
            ? state?.module?.name.toLowerCase()
            : moduleName?.toLowerCase()
        }
      />
    </Column>
  );
};

export default ProductSetup;
